export default {
  edit: 'Edit',
  invite: 'Invite',
  resendInvite: 'Resend Invite',
  moveToInvited: 'Move to Invited',
  notifyUserManager: 'Notify',
  lock: 'Lock',
  unlock: 'Unlock',
  manualLock: 'Manual Lock',
  cancelAutolock: 'Cancel Autolock',
  successInvite: 'Invitation email has been sent',
  successInviteResend: 'Invitation email has been resent',
  successEmailToUserManager: 'Email has been sent to the User Manager',
  successMoveToInvited: 'The user has been moved to the Invited status',
};
